<template lang="pug">
	.voices-showcase-link
		.flex-col.space-large.padding
			.font-big.upper {{$tCaption('Voices showcase')}}
			.flex-row.space(:class="{ 'disabled-controls': isLoading }")
				DxButton(:text="$tCaption('Browse')", @click="open(false)", icon="search")
				DxButton(:text="$tCaption('Get link (edit mode)')", @click="open(true)", icon="edit")
		Loader(v-if="isLoading", text="", :fullscreen="true")
</template>

<script>
	import DxButton from 'devextreme-vue/button';
	import Loader from 'app-core/Loader.vue';

	export default {
		translationCategory: 'insertion.VoiceShowcaseLink',
		name: 'voices-showcase-link',
		props: [],
		components: { DxButton, Loader },
		data() {
			return {
				isLoading: 0
			};
		},
		computed: {
		},
		watch: {
		},
		mounted() {
			if (__DEBUG__)
				window.voicesShowcaseLink = this;
		},
		destroyed() {
		},
		methods: {
			async open(editMode) {
				this.isLoading++;
				let url = await this.$Data.getExternalApi('company/GetVoiceShowcaseEditUrl').finally(() => this.isLoading--);
				if (!editMode) {
					let u = new URL(url);
					url = u?.origin;
				}

				if (editMode && navigator?.clipboard?.writeText) {
					navigator.clipboard.writeText(url);

					this.$notifySuccess('Link has been copied to clipboard');
				} else {
					window.open(url, '_blank');
				}
			}
		}
	};
</script>
<style lang='scss'>
	@import "main/themes/generated/variables.base.scss";

	.voices-showcase-link {
		
	}
</style>
